import { useSuperAdminAuthStore } from "store/superAdminAuth";

export default function superAdminAuthHeader() {
  const token = useSuperAdminAuthStore.getState().getToken();

  if (token) {
    return {"x-auth-token": token};
  } else {
    return {};
  }
}

